import React from "react"; 

// core components
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Table from "../../views/Table/Table.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardBody from "../../views/Card/CardBody.js";

import axios from 'axios'
import style from './styles.module.css'
import Button from '@material-ui/core/Button'
import ConfLocation from './confLocation/ConfLocation'
import IconButton from '@material-ui/core/IconButton'
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import Snackbar from '../utils/snackbar/Snackbar'
import {withRouter} from 'react-router-dom' 
import CircularProgress from '@material-ui/core/CircularProgress'
import TopBar from "../utils/Topbar/TopBar.js";
import {connect} from 'react-redux'
import {getLocations} from '../../containers/app/actions'
import SplitButton from "../utils/SplitButton/SplitButton.js";
import {getGoDown} from '../../containers/app/actions'

const Location = (props) => { 
  const [filteredData,setFilteredData] = React.useState(false)
  const [searchValue,setSearchValue] = React.useState("")

  const [alert,setAlert] = React.useState(false);
  const [addModal,setAddModal] = React.useState(false);
  const [editModal,setEditModal] = React.useState(false);
  const [activeLocation,setLocation] = React.useState(false) 
  const [goDown,setGoDown] = React.useState([]);


  React.useEffect(() => {
    props.getLocations(props.user._id)
  },[]);

  React.useEffect(() => {
    if(!props.goDown) {
      props.getGoDown(props.user._id);
    } else {
      setGoDown(props.goDown)
    }
  },[props.goDown])
 

  React.useEffect(() => {
    if(props.locations) {
      let arr = [];
      arr = props.locations.filter(val => {
        if(val.name.toLowerCase().includes(searchValue.toLowerCase())) {
          return val;
        }
      }) 
      setFilteredData(arr);
    } else {
      setFilteredData(false);
    }
  },[searchValue,props.locations]);


  const handleDelete = (value) => {
    axios({
      method: "post",
      url: "/deleteLocation",
      data: {
        locationId: value._id,
        userId: props.user._id
      }
    }).then(res => {
      setAlert("Deleted Successfully")
      props.getLocations(props.user._id);
    }).catch(err => {
      setAlert("Something went wrong");
    })
  }

  const isLoading = !filteredData;
  const showData = !isLoading;
  const details = [];

  
  !isLoading && filteredData.forEach(val => {
    details.push(
      [
        val._id,
        val.name,
        val.uniqueCode, 
        val.godown ? val.godown.name : "NULL",
        <React.Fragment>  
          <IconButton onClick={() => {
            setLocation(val)
            setEditModal(true)
          }}>
            <EditRoundedIcon />
          </IconButton>

          <IconButton onClick={() => handleDelete(val)}>
            <DeleteRoundedIcon />
          </IconButton>
        </React.Fragment>
      ]
    )
  });


  return (
    <GridContainer>
      
      <ConfLocation
        type="ADD" 
        open={addModal} 
        onClose={() => setAddModal(false)} 
        onDone={() => {
          setAddModal(false)
          props.getLocations(props.user._id)
        }}
        setAlert={(msg) => setAlert(msg)}
        goDown={goDown}
      />
      {activeLocation && <ConfLocation 
        type="EDIT"
        location={activeLocation} 
        open={editModal} 
        onClose={() => setEditModal(false)} 
        onDone={() => {
          setEditModal(false)
          setLocation(false)
          props.getLocations(props.user._id)
        }} 
        goDown={goDown}
        setAlert={(msg) => setAlert(msg)}
      />} 
 
      <Snackbar open={alert} handleClose={() => setAlert(false)}/>
 
      <TopBar 
        searchValue={searchValue} 
        onSearchChange={(value) => setSearchValue(value)}  
        nav={[
          {Name: "WareHouse",onClick: () => props.history.push("/admin/warehouses")},
          {Name: "Location",onClick: () => {}}
        ]}
      />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>All Locations</h4> 

              <div className={style.buttons}>
                <SplitButton
                  options={
                    [ {name: "Godown",onClick: () => props.history.push("/admin/godown")},
                      {name: "Location",onClick: () => props.history.push("/admin/location")}, 
                    ]
                  }
                  name={"Explore"}
                  color="secondary"
                />

                <Button color="secondary" variant="contained" onClick={() => setAddModal(true)}>Add Location</Button> 
              </div>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading &&
              <div className={style.loader}>
                <CircularProgress />
              </div>
            }
            
            {showData && 
              <Table
                tableHeaderColor="primary"
                tableHead={["#Id", "Name", "Code","Godown","Action"]}
                tableData={details}
              />}
          </CardBody>
        </Card>
      </GridItem> 
    </GridContainer>
  );
}

const mapStateToProps = state => ({
  user: state.appReducer.user,
  locations: state.appReducer.locations, 
  goDown: state.appReducer.goDown
})
export default withRouter(connect(mapStateToProps, {getLocations,getGoDown})(Location));